export default {
    itemDescription: {
        width: '80%'
    },
    itemQuantity: {
        width: '15%'
    },
    removeItem: {
        width: '5%'
    }
};
